import InvitationScreen from './invitation-screen.component';

export default InvitationScreen;
